
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`এটি
                    <a href="${0}">ফোকসনোমি ইঞ্জিন প্রকল্প</a>দ্বারা আনা হয়েছে। অংশগ্রহণ করতে বা প্রতিক্রিয়া জানাতে
                    দ্বিধা করবেন না।`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`এই টুলটি আপনাকে উপাদান তালিকা সংশোধন করতে সাহায্য করে। আপনি
                উপাদান তালিকা যোগ করতে, অপসারণ করতে বা সম্পাদনা করতে পারেন।
                <br>
                এই অক্ষরটি <span class="highlight">␣</span> একটি স্থানকে প্রতিনিধিত্ব করে।
                <br>
                এই অক্ষরটি <span class="highlight">↩︎</span> একটি লাইন বিরতিকে প্রতিনিধিত্ব করে। `,
'hb28f1f2ec1744ee9': html`এই বৈশিষ্ট্যগুলি ব্যবহারকারীরা যেকোনো ধরণের ব্যবহারের জন্য তৈরি এবং ফাইল করে।
                    আপনার নিজস্ব বৈশিষ্ট্য যোগ করতে দ্বিধা করবেন না। আপনার তৈরি করা বৈশিষ্ট্য এবং মানগুলি
                    <strong>অবশ্যই বাস্তবসম্মত হতে হবে</strong>। আপনি
                    <a href="${0}">সম্প্রদায় দ্বারা ইতিমধ্যে ব্যবহৃত বৈশিষ্ট্যগুলির তালিকা</a>
                    দেখতে পারেন অথবা
                    <a href="${1}">বৈশিষ্ট্যের ডকুমেন্টেশন এবং এর সার্চ ইঞ্জিন</a>অন্বেষণ করতে পারেন।`,
's000a5b76bd3a01c2': `বৈশিষ্ট্য লোড হচ্ছে...`,
's000d98595e959c1e': `গুগল প্লে-তে পান`,
's013bdc8cf0d3583d': `উপকরণের জন্য আমাদের সাহায্য করুন`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `ক্রপ যাচাই করুন`,
's03e9c8114521b998': `আমি উপকরণগুলো সম্পাদনা করব।`,
's05ec315d9308091a': `বারকোড কর্নার আইকন`,
's061eb5af92512c85': `সেভ করা হয়েছে! আপনি কি অন্য একটিতে সাহায্য করতে পারেন?`,
's06847c221c4c0bc1': `আমি [আপনার ব্যবহারের ধরণ বর্ণনা করার জন্য] একটি সম্পত্তি তৈরি করতে চাই...`,
's06f6c6f99db6b552': `মূল`,
's081e2ad82db71e1d': `গোষ্ঠীবদ্ধ মান`,
's09205907b5b56cda': `না`,
's0b4235aae602a950': `নিবেদিতপ্রাণ ডকুমেন্টেশন`,
's0bb2d48532acc455': `সিএসভি ডাউনলোড করুন`,
's0d5b7fee0311db68': `সম্পত্তি`,
's0fb218abc2e157ed': `ছবি অবৈধ করুন`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `ক্রপ বাতিল করুন`,
's11a18a69b30b65ed': `উপাদান তালিকার ত্রুটিগুলি ঠিক করতে আমাদের সাহায্য করুন`,
's1205d5f6fccf8e69': `সম্পত্তির মূল্য`,
's15d64a0a6715285a': `নতুন কী`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `নির্বাচন এলাকা`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `পুষ্টির তথ্য সংশোধন করতে আমাদের সাহায্য করুন`,
's1e00019dc454872d': `property-name অ্যাট্রিবিউট ব্যবহার করে একটি property নাম প্রদান করুন।`,
's1e49126af0935a5b': `এই সম্পত্তি ব্যবহার করে এমন পণ্যের তালিকা`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `সম্পত্তির নথিপত্র তৈরি করুন`,
's300b3a6ee4e1252d': str`খারাপ ম্যাচ ${0}%`,
's33f786bb6b4f0cf4': `ফসলের ফলাফল`,
's33f85f24c0f5f008': `সংরক্ষণ করুন`,
's34be4af4e8fec4ae': `প্রথমে সম্প্রদায়কে জিজ্ঞাসা করুন`,
's36d86adc823cbfa6': `নতুন সম্পত্তি তৈরি করার আগে, সম্প্রদায়ের সাথে এটি নিয়ে আলোচনা করুন:`,
's3781d25aa51a736c': `ফোকসনোমি ইঞ্জিন ডকুমেন্টেশন`,
's383ae4449428b61e': `ক্রপ রিসেট করুন`,
's39bcf88721a1e8ee': `নির্বাচন রিসেট করুন`,
's39e14e14300694c7': `ডকুমেন্টেশন এবং নির্দেশিকা`,
's3b430cfa5c1fe7f4': str`${0}এর জন্য ডকুমেন্টেশন`,
's3f4e4b52f230a892': `ছবির ক্যানভাস`,
's417b90913e05bc17': `প্রিভিউ`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `ছবি কেন্দ্রে রাখুন`,
's42dd66b2441566fd': `কেন্দ্র আইকন`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `একটি পুষ্টি যোগ করুন`,
's453ab0dbb9b5c777': `ডানদিকে আকার পরিবর্তন করুন`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `পণ্যের সংখ্যা`,
's4df2f533c0c1e7d0': `চিত্র নিয়ন্ত্রণ`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `নির্বাচন সরান`,
's4f751fb9b3ed766c': `একটি নতুন সম্পত্তি তৈরি করা`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `সম্পত্তির নাম লিখুন...`,
's55d7249883a98ca1': `ওপেন ফুড ফ্যাক্টস উইকিতে এই সম্পত্তি সম্পর্কে`,
's565867d84c04aea2': `ফিল্টার বৈশিষ্ট্য...`,
's5666afe5cd0166de': `নিশ্চিত করার আগে দয়া করে ত্রুটিগুলি ঠিক করুন অথবা লেখাটি পরিবর্তন করুন।`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `পণ্য লোড হচ্ছে...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `পুষ্টির তথ্য সংশোধন করতে আমাদের সাহায্য করুন।`,
's5dd6f12783fca34f': `উপাদানের তালিকা সম্পাদনা করুন`,
's5e8250fb85d64c23': `বন্ধ করুন`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edit`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `আপনার অবদানের জন্য ধন্যবাদ!`,
's6cee7cad81dfedd1': `ছাঁটা ছবি`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`ভালো মিল ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `ডকুমেন্টেশন`,
's787dd11bed0dc88a': `বাম দিকের আকার পরিবর্তন করুন`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `সম্পত্তি তৈরি এবং নির্দেশিকা সম্পর্কে আরও জানুন:`,
's8038273de2cf8b73': `ক্রপ করার জন্য একটি অঞ্চল নির্বাচন করুন।`,
's839cc2908a5387f2': `বারকোড ফিল্টার করুন...`,
's86197dcf3e96af64': `বিদ্যমান বৈশিষ্ট্যগুলি ব্রাউজ করুন এবং অনুসন্ধান করুন`,
's8a63be30a129a59c': `নীচের আকার পরিবর্তন করুন`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `উপরে ডানদিকে আকার পরিবর্তন করুন`,
's8db84aa4bc949af2': `নতুন সম্পত্তি নথিভুক্ত করুন`,
's8f839a03997a16d7': `পণ্য দেখুন`,
's901ae1e236ac45d3': `মুছে ফেলা বাতিল করুন`,
's907f7a97c6b29425': `ডেটা মডেলটি পরিবর্তন করা হতে পারে বলে মনে রাখবেন। আপনার নিজের ঝুঁকিতে ব্যবহার করুন।`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `উপকরণ :`,
's9a7f60fce090ecaf': `বৈশিষ্ট্য লোড করা যায়নি। অনুগ্রহ করে পরে আবার চেষ্টা করুন।`,
's9b87abd68fb9df45': `খুঁজে পাওয়া যায়নি? নতুন কী তৈরি করুন {value}`,
's9c0f52425fd2f07e': `মিল নাও হতে পারে`,
's9fc41f789c63b40d': `পণ্য`,
'sa1fa766e0d5634d7': `কোন স্কোর পাওয়া যাচ্ছে না`,
'sa548778b24054030': `ফোকসনোমি ইঞ্জিন প্রকল্প থেকে সমস্ত অবদানকৃত বৈশিষ্ট্যগুলি অন্বেষণ করুন। এই বৈশিষ্ট্যগুলি ওপেন ফুড ফ্যাক্টস ডাটাবেসে পণ্য সম্পর্কে অতিরিক্ত মেটাডেটা এবং অন্তর্দৃষ্টি প্রদান করে।`,
'sa63907958bd0ec4b': `উপরের বাম দিকে আকার পরিবর্তন করুন`,
'sa95b4224f685a36a': `মোডাল বন্ধ করুন`,
'sab56a1d439576fd6': `পরামর্শ আইকন`,
'sac47ea2901d04c15': `নীচে বাম দিকের আকার পরিবর্তন করুন`,
'sb125227d436c2925': `বিদ্যমান সম্পত্তি ডাটাবেসে আপনার সম্পত্তি ধারণাটি অনুসন্ধান করুন:`,
'sb125568d43642e6f': `পণ্য সম্পর্কে প্রশ্নের উত্তর দিন।`,
'sb1c538e038f9b214': str`খুব ভালো মিল ${0}%`,
'sb28639570ff3b852': `সকল সম্পত্তির তালিকা`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `একবার আপনি যাচাই করে ফেললেন যে আপনার সম্পত্তির অস্তিত্ব নেই এবং সম্প্রদায় এটি কার্যকর বলে সম্মত হয়েছে, তাহলে আপনাকে প্রথমে এটি উইকিতে নথিভুক্ত করতে হবে।`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `এই সম্পত্তির জন্য কোন পণ্য পাওয়া যায়নি।`,
'sb7f72e4c8a2d3357': `ফিল্টার মান...`,
'sb8178320160f84ea': `ক্রপ দেখান`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `সমস্ত অন্তর্দৃষ্টির উত্তর দেওয়া হয়েছে! আপনার সাহায্যের জন্য ধন্যবাদ!`,
'sbd9a0b2293b3cd3c': `পরিবেশন পরিমাপ`,
'sbe472dc3c2685985': `সংশ্লিষ্ট মান`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `উপরের অংশের আকার পরিবর্তন করুন`,
'sc1c08d0cbcc3bd24': `মিলছে না`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `প্রস্তাবিত সমাধান`,
'sc681b137e8f604f7': `মুছে ফেলা নিশ্চিত করুন`,
'sc6daf8a31883f8b9': `ছবি সরান`,
'sc895972c88d38ca5': `ফোকসনোমি সম্পত্তি`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `সারি`,
'scb3b0671d7b7f640': `নতুন মান`,
'scb489a1a173ac3f0': `হ্যাঁ`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `স্ল্যাক আলোচনায় যোগ দিন`,
'scdb6cad0b92721bf': `কোন সম্পত্তি পাওয়া যায়নি।`,
'scf23a05631f93732': `মুছে ফেলা নিশ্চিত করুন`,
'scfed2f270ef6a3aa': `এলাকা নির্বাচন করুন`,
'sd1022bc1ef9204f7': `জুমযোগ্য ছবি`,
'sd1077c055cf9ba6b': `পণ্যের উপাদান তালিকা যাচাই করতে আমাদের সাহায্য করুন।`,
'sd698d21ddecba56b': `হে! আপনি নিম্নলিখিত অংশগুলির উত্তর দিয়ে পণ্যের তথ্য উন্নত করতে আমাদের সাহায্য করতে পারেন:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `কোনও সম্পত্তি ইতিমধ্যেই আছে কিনা তা পরীক্ষা করুন`,
'sdbf806fefc584115': `তোমার একটা খুঁজে বের করা উচিত`,
'sdc673e73b5c13aea': `মুছুন`,
'sdc792b75f1edcaba': `উপাদানগুলির বানান সংশোধন করতে আমাদের সাহায্য করুন।`,
'sdca5deead576ceee': `নীচের ডানদিকে আকার পরিবর্তন করুন`,
'sdcc2555c5dde524f': `আপনি কি নিশ্চিত যে আপনি এই আইটেমটি মুছে ফেলতে চান? এই ক্রিয়াটি পূর্বাবস্থায় ফেরানো যাবে না।`,
'se206feec7ec57b28': `প্রতি ১০০ গ্রাম`,
'se419a9ab36987490': `বাতিল করুন`,
'se5127cf0f92e7e48': `পরামর্শ: আপনি এটিও খুঁজে পেতে পারেন`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `আমি আরও ভালো ফসলের প্রস্তাব দেব।`,
'seea3800e27baa686': `ব্যক্তিগত পণ্য`,
'sefaba4adc4ec9219': `ফোকসনোমি বৈশিষ্ট্য`,
'seffa8ca49175b5f0': `ব্যক্তিগতকৃত সম্পত্তি`,
'sf44a6b3b232c28ea': str`বর্তমান মান ${0}দিয়ে প্রতিস্থাপন করুন`,
'sf4cd86a2f5ef2588': `পণ্য বারকোড`,
'sf57a61152168cc81': `উপাদান সনাক্তকরণ সংশোধন করতে আমাদের সাহায্য করুন`,
'sf88b90b8ba23871c': `অজানা মিল`,
'sf9aee319a006c9b4': `যোগ`,
'sfacbbe968fa7d773': `সম্পত্তির নাম:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `সংশ্লিষ্ট মান`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  